import { Checkout } from './Checkout';

function App() {
  return (
    <>
      <Checkout />
    </>
  );
}

export default App;
